var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"condizioni-generali"},[_c('div',{staticClass:"default-container default-container-smaller"},[_c('h1',[_vm._v("Cookie Policy")]),_c('div',{staticClass:"cookiebot-policy-wrap"})])])
}]

export { render, staticRenderFns }